module.exports = __webpack_public_path__ + "assets/img/ear.5be6a16c.png";